<template>
  <v-expansion-panels class="ReportsCardExpansionPanels" v-model="expansionPanel" focusable>
    <v-expansion-panel class="CardExpansionPanel d-flex flex-column-reverse">
      <v-expansion-panel-header class="d-flex justify-center" @click="clickExpandDeviceReportPanel">
        <div class="d-none" />
        <template v-slot:actions >
          <v-icon x-large class="ma-0 flex-1">expand_more</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div
          v-for="loc in activeLocations"
          :key=loc.name
          class="ma-5"
        >
          <CardDetails :location="loc" :title="title"/>
          <p
            class="LocationComment subheading my-4 py-2"
            v-if="loc.details.location_comment"
          >*{{loc.details.location_comment}}</p>
          <v-divider></v-divider>
          <CardCircularGraphics :locationName="loc.name" :circGraphsData="loc.circularGraphics" :title="title"/>
          <CardLinearGraphics :location="loc" :title="title"/>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import CardDetails from './CardDetails'
import CardCircularGraphics from './CardCircularGraphics'
import CardLinearGraphics from './CardLinearGraphics'
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../constants/const'

export default {
  components: {
    CardDetails,
    CardCircularGraphics,
    CardLinearGraphics
  },
  props: ['locations', 'optLocations', 'title', 'equipData'],
  data () {
    return {
      expansionPanel: null
    }
  },
  computed: {
    activeLocations () {
      return this.locations.filter((loc, i) => this.optLocations[i].checked)
    }
  },
  methods: {
    clickExpandDeviceReportPanel () {
      if (this.expansionPanel === null) {
        trackEvent(EVENTS_TO_TRACK.EXPAND_DEVICE_REPORT_PANEL, {deviceId: this.equipData.id, deviceName: this.equipData.name})
      } else {
        trackEvent(EVENTS_TO_TRACK.COLLAPSE_DEVICE_REPORT_PANEL, {deviceId: this.equipData.id, deviceName: this.equipData.name})
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// CardExpansionPanel.vue?8768ea40